import React, { memo, useEffect, useState } from 'react'
import { Button, TextInput } from '../../common'
import BgBestProperties from '../../../assets/bg_best_properties_dark.webp'
import BgCarouselHome2 from '../../../assets/carousel-home-2.webp'
import BgCarouselHome3 from '../../../assets/carousel-home-3.webp'
import BgCarouselHome4 from '../../../assets/carousel-home-4.webp'
import BgCarouselHome5 from '../../../assets/carousel-home-5.webp'
import ModalFilter from '../../Modais/ModalFilter'
import MicrophoneIcon from '../../../assets/icons/microphone-blue.svg'
import {
  FULL_TEXT,
  HISTORICO_BUSCAS,
  LOCATIONS,
  SEL_ARGUMENTS_AUTOCOMPLETE
} from '../../../constants/storageNames'
import { Cookies } from 'react-cookie'
import { isMobile, isValidList } from '../../../common_functions'
import search from '../../../store/reducers/search'
import SeparatorMicrophoneGray from '../../../assets/icons/separator-microphone-gray.svg'
import Voice2Text from '../../Voice2Text'
import { Argument } from '../../../interfaces/arguments'
import SearchAutocomplete from '../../SearchAutoComplete'
import { ModalBuscaVoz } from '../../Modais/ModalBuscaVoz'
import Voice2TextBusca from '../../Voice2TextBusca'

let listSuggestions = [
  'Área privativa espaçosa para churrasco',
  'Cobertura com vista panorâmica',
  'Imóvel com home office ',
  'Condomínio com academia completa ',
  'Apartamento com varanda ',
  'Imóvel com espaço pet-friendly ',
  'Casa com suíte e closet ',
  'Imóvel com playground para crianças',
  'Apartamento com lavanderia '
]

function SectionBestPropertiesFullText() {
  const [showModal, setShowModal] = useState(false)
  const [valueInput, setValueInput] = useState('')
  const [keyPress, setKeyPress] = useState<string>('')
  const [selectedArguments, setSelectedArguments] = useState<Argument[]>()
  const [focusOut, setFocusOut] = useState(false)
  const [isVoiceTxt, setIsVoiceTxt] = useState(false)
  const [showEmptySuggestions, setShowEmptySuggestions] = useState(false)
  const [countIndexSuggestion, setCountIndexSuggestion] = useState(0)
  const [placeholder, setPlaceholder] = useState('')
  const [translatePlaceholder, setTranslatePlaceholder] = useState('')
  const images = [BgBestProperties, BgCarouselHome2, BgCarouselHome3, BgCarouselHome4]
  const [indexBg, setIndexBg] = useState(0)

  const cookies = new Cookies()
  const [originalList, setOriginalList] = useState<string[]>([])

  const updateListOriginByCookies = () => {
    let locationsCookies = cookies.get(LOCATIONS)?.split(',') ?? ''
    setOriginalList(locationsCookies)
  }

  // useEffect(() => {
  //   if (countIndexSuggestion == listSuggestions.length - 1) {
  //     setCountIndexSuggestion(0)
  //   } else {
  //     setCountIndexSuggestion(countIndexSuggestion + 1)
  //   }
  //   setTimeout(() => {
  //     setPlaceholder(listSuggestions[countIndexSuggestion])
  //   }, 2000)
  // }, [placeholder])

  const translatedFakePlaceholder = () => {
    const fakeDiv = document.getElementById('fakePlaceholder')
    if (fakeDiv) {
      const translated = fakeDiv.innerText
      setTranslatePlaceholder(translated)
    }
  }
  useEffect(() => {
    const interval = setInterval(() => {
      setCountIndexSuggestion((prev) => (prev + 1) % listSuggestions.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setIndexBg((prev) => (prev + 1) % images.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    setPlaceholder(listSuggestions[countIndexSuggestion])

    setTimeout(() => {
      translatedFakePlaceholder()
    }, 500)
  }, [countIndexSuggestion])

  useEffect(() => {
    if (placeholder == '') {
      setTranslatePlaceholder(listSuggestions[0])
    }
  }, [])

  useEffect(() => {
    if (!isValidList(originalList)) {
      updateListOriginByCookies()
    }
  }, [location.pathname])

  useEffect(() => {
    let enderecoBuscaEmpreendimentoHTML = document.querySelector(
      '#enderecoBuscaEmpreendimento'
    ) as HTMLElement
    if (enderecoBuscaEmpreendimentoHTML != undefined && !isValidList(originalList))
      enderecoBuscaEmpreendimentoHTML.addEventListener('focus', updateListOriginByCookies)
  }, [])

  const updateSelectedArguments = (valInput?: string) => {
    let updatedSelectedArguments = selectedArguments
    let val = valInput ?? valueInput
    selectedArguments?.forEach((element) => {
      if (!val.toLowerCase().includes(element.Title.toLowerCase())) {
        updatedSelectedArguments = updatedSelectedArguments?.filter((x) => x != element)
      }
    })
    sessionStorage.setItem(SEL_ARGUMENTS_AUTOCOMPLETE, JSON.stringify(updatedSelectedArguments))
  }

  const handleSearch = () => {
    const locals = sessionStorage.getItem(HISTORICO_BUSCAS)
    sessionStorage.setItem(HISTORICO_BUSCAS, `${locals}&${search}`)
    // sessionStorage.setItem(FULL_TEXT, valueInput)
    updateSelectedArguments()
    searchEnterprise()
  }

  const handleSearchKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    setKeyPress(e.key)
    if (e.key == 'Enter') {
      sessionStorage.setItem(FULL_TEXT, valueInput)
      handleSearch()
    }
  }

  const searchEnterprise = (valInput?: string) => {
    let val = valInput ?? valueInput
    let strBuscaURL = `?search=enterprises&fullText=${val}`
    window.location.href = `/busca/${strBuscaURL}`
  }

  const handleChangeTranscript = (transcript: string) => {
    setValueInput(transcript.trim())
  }

  const handleChangeInput = (val: string) => {
    setValueInput(val)
    // sessionStorage.setItem(FULL_TEXT, val)
  }

  const focusInput = () => {
    setFocusOut(false)
    setShowEmptySuggestions(true)
  }

  const handleBlurInput = () => {
    setFocusOut(true)
    setTimeout(() => {
      setShowEmptySuggestions(false)
    }, 500)
  }

  const handleSearchByVoice = (valInput: string) => {
    const locals = sessionStorage.getItem(HISTORICO_BUSCAS)
    sessionStorage.setItem(HISTORICO_BUSCAS, `${locals}&${search}`)
    updateSelectedArguments(valInput)
    searchEnterprise(valInput)
  }

  return (
    <section className="section-best-properties h-[calc(100vh-60px)] lg:h-auto md:aspect-auto flex">
      <div className="relative w-full lg:h-auto h-[calc(100vh-60px)] md:min-h-[654px] rounded-lg md:rounded-none overflow-hidden">
        {images.map((img, i) => (
          <div
            key={i}
            style={{
              backgroundImage: `url(${img})`
              // height: heightSection
            }}
            className={`
        absolute inset-0
        w-full h-auto content-end md:content-center lg:content-normal
        bg-cover bg-no-repeat bg-top rounded-lg md:rounded-none
        transition-opacity duration-500
        ${i === indexBg ? 'opacity-100 z-10' : 'opacity-0'}
      `}
          >
            <div
              className="h-full w-full content-end md:content-center lg:content-normal content-best-properties lg:pb-0"
              style={{ backdropFilter: `${i == 0 ? '0' : 'brightness(0.6)'}` }}
            >
              <div
                id="containerSearchProperty"
                data-padding={40}
                className={
                  'container-search-property max-w-[1000px] rounded-lg mx-5 md:w-4/5 m-auto text-center py-6 lg:ps-[10rem] relative md:-bottom-[16rem] left-0 right-0 md:m-auto lg:ms-0'
                }
              >
                <h2 className="text-2xl lg:text-5xl lg:text-start text-[#FFFFFF] mt-5 lg:w-[75%]">
                  Encontre seu imóvel novo por texto ou voz no{' '}
                  <span className="text-[#FF9A00] font-bold">glemO</span>
                </h2>
                <div id="fakePlaceholder" className="opacity-0 h-0">
                  {placeholder}
                </div>
                <div className="w-full mt-8">
                  <div className="grid lg:grid-cols-7 gap-3 lg:gap-2">
                    <div className="lg:col-span-5">
                      <div className="flex px-2 rounded text-md border-1 border-gray-200 outline-none placeholder:text-gray-600 max-w-100 bg-white">
                        <TextInput.Root className="border-none bg-white">
                          <TextInput.Input
                            onChange={(e) => handleChangeInput(e.target.value)}
                            value={valueInput}
                            onBlur={handleBlurInput}
                            onFocus={focusInput}
                            onKeyUp={(e) => handleSearchKey(e)}
                            className={`w-full bg-transparent text-xl input-search-best-properties-full-text`}
                            placeholder={translatePlaceholder}
                          />
                        </TextInput.Root>
                        <div className="text-center m-auto pe-2">
                          <img src={SeparatorMicrophoneGray} alt="Separador" />
                        </div>
                        <div className="text-center m-auto cursor-pointer">
                          <Voice2TextBusca />
                          {/* <img src={MicrophoneIcon} onClick={() => setShowModalBusca(true)} /> */}
                          {/* <Voice2Text
                      changeTranscript={(transcript: string) => handleChangeTranscript(transcript)}
                    /> */}
                        </div>
                      </div>
                      <div className="hidden lg:block">
                        <SearchAutocomplete
                          changedInputValue={valueInput}
                          onInputKeydown={keyPress}
                          classNameMaxHeight='max-h-[180px]'
                          // classNameSuggestionsContainer='max-h-[150px]'
                          classNameSearchHTML="input-search-best-properties-full-text"
                          handleSearch={handleSearch}
                          isVoiceTxt={isVoiceTxt}
                          changeInputValue={(val) => setValueInput(val)}
                          changeSelectedArguments={(args) => setSelectedArguments(args)}
                        />
                      </div>
                    </div>
                    <div className="lg:col-span-2 lg:h-full text-center max-w-100">
                      <Button
                        id="searchBestProperties"
                        variant="primary"
                        onClick={handleSearch}
                        className="font-bold w-full text-xl lg:h-full lg:w-[200px] max-w-100"
                      >
                        BUSCAR
                        <span className="ps-2">
                          <svg
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_8760_453)">
                              <path
                                d="M13.9999 13.6755L10.347 10.0227C11.2959 8.86221 11.7624 7.38141 11.6501 5.8866C11.5378 4.3918 10.8552 2.99734 9.74363 1.99166C8.63201 0.985992 7.17638 0.446048 5.67783 0.483517C4.17927 0.520985 2.75245 1.133 1.69248 2.19297C0.632509 3.25294 0.0204952 4.67976 -0.0169734 6.17832C-0.0544419 7.67687 0.485502 9.1325 1.49117 10.2441C2.49685 11.3557 3.89131 12.0383 5.38611 12.1506C6.88092 12.2629 8.36172 11.7964 9.5222 10.8475L13.175 14.5004L13.9999 13.6755ZM5.8332 11.0004C4.91022 11.0004 4.00797 10.7267 3.24054 10.2139C2.47311 9.70111 1.87498 8.97227 1.52177 8.11955C1.16856 7.26683 1.07614 6.32852 1.25621 5.42327C1.43627 4.51803 1.88073 3.68651 2.53337 3.03386C3.18602 2.38122 4.01754 1.93676 4.92278 1.7567C5.82803 1.57663 6.76634 1.66905 7.61906 2.02226C8.47178 2.37547 9.20062 2.9736 9.7134 3.74103C10.2262 4.50846 10.4999 5.41071 10.4999 6.33369C10.4985 7.57094 10.0064 8.75712 9.1315 9.63199C8.25663 10.5069 7.07045 10.999 5.8332 11.0004Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_8760_453">
                                <rect
                                  width="14"
                                  height="14"
                                  fill="white"
                                  transform="translate(0 0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
                <ModalFilter
                  show={showModal}
                  close={() => setShowModal(false)}
                  elementInputCityId="inputSearchEnterprisesSectionBestProperties"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="lg:hidden">
              <SearchAutocomplete
                changedInputValue={valueInput}
                onInputKeydown={keyPress}
                classNameSuggestionsContainer="left-[15px] top-[87vh]"
                // classNameSuggestionsContainer='max-h-[150px]'
                classNameSearchHTML="input-search-best-properties-full-text"
                handleSearch={handleSearch}
                isVoiceTxt={isVoiceTxt}
                changeInputValue={(val) => setValueInput(val)}
                changeSelectedArguments={(args) => setSelectedArguments(args)}
              />
            </div>
    </section>
  )
}
export default memo(SectionBestPropertiesFullText)
